import { PainPointsSlider } from "@/components/ui/pain-points-slider";

export default function PainPointsSection() {
  return (
    <section
      id="dolor"
      data-testid="pain-points-section"
      className="py-0 relative scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Title */}
        <div className="text-center mb-12">
          <p className="text-sm sm:text-base uppercase tracking-[0.2em] font-bold text-cyan-400 mb-4">
            Problema
          </p>
          <h2
            data-testid="pain-points-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-white"
            style={{ fontFamily: "Fraunces, serif" }}
          >
            ¿Te identificas con esto?
          </h2>
        </div>

        {/* Carousel */}
        <PainPointsSlider />
      </div>
    </section>
  );
}
